module.exports = __webpack_public_path__ + "img/offers.2b2f7965.svg";